import React, { useState } from "react";
import "./ApplicationForm.css";
import { useSearchParams } from "react-router-dom";
import formImg from "../../Assests/images/formImg.jpg";
import Popup from "../Popup/Popup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ApplicationForm = () => {
  const [errors, setErrors] = useState([]);
  const [popup, setPopup] = useState({ show: false, message: "", type: "" });
  const [searchParams] = useSearchParams();
  const trekName = searchParams.get("trek") || "Unknown Trek";

  // Pickup points & food options come from the admin-generated link's query params.
  // Fall back to sensible defaults if the link doesn't carry them.
  const parseList = (key, fallback) => {
    const raw = searchParams.get(key);
    if (!raw) return fallback;
    const items = raw
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    return items.length ? items : fallback;
  };

  const pickupOptions = parseList("pickups", ["Nashik Phata", "Deccan"]);
  const foodOptions = parseList("foods", ["Veg"]);

  const createInitialForm = () => ({
    trekName: trekName,
    fullName: "",
    age: "",
    gender: "",
    bloodGroup: "",
    address: "",
    mobile: "",
    email: "",
    pickupPoint: "",
    foodPreference: foodOptions[0] || "Veg",
    medicalCondition: "",
    medicalConditionDetails: "",
    emergencyName: "",
    emerContactNumber: "",
    emergencyRelation: "",
  });

  const [forms, setForms] = useState([createInitialForm()]);

  const validateForm = () => {
    const newErrors = [];

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const nameRegex = /^[A-Za-z\s]+$/;
    const mobileRegex = /^[0-9]{10}$/;

    forms.forEach((form, index) => {
      const currentErrors = {};

      if (!form.fullName || !nameRegex.test(form.fullName)) {
        currentErrors.fullName =
          "Full name is required and should contain only letters";
      }

      if (!form.age) {
        currentErrors.age = "Please select an age group";
      }
      if (!form.gender) currentErrors.gender = "Gender is required";
      if (!form.bloodGroup)
        currentErrors.bloodGroup = "Blood group is required";



      if (!form.mobile || !mobileRegex.test(form.mobile)) {
        currentErrors.mobile = "Enter a valid 10-digit mobile number";
      }

      if (!form.pickupPoint)
        currentErrors.pickupPoint = "Pickup point is required";
      if (!form.foodPreference)
        currentErrors.foodPreference = "Food preference is required";

      if (!form.medicalCondition)
        currentErrors.medicalCondition =
          "Medical condition selection is required";
      if (form.medicalCondition === "Yes" && !form.medicalConditionDetails) {
        currentErrors.medicalConditionDetails =
          "Please specify medical condition details";
      }

      if (!form.emergencyName || !nameRegex.test(form.emergencyName)) {
        currentErrors.emergencyName =
          "Emergency name is required and should contain only letters";
      }

      if (
        !form.emerContactNumber ||
        !mobileRegex.test(form.emerContactNumber)
      ) {
        currentErrors.emerContactNumber =
          "Enter a valid emergency contact number";
      }

      if (!form.emergencyRelation)
        currentErrors.emergencyRelation = "Emergency relation is required";

      newErrors.push(currentErrors);
    });

    setErrors(newErrors);

    return newErrors.every((err) => Object.keys(err).length === 0);
  };
  const validateSingleField = (index, field, value, form) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const nameRegex = /^[A-Za-z\s]+$/;
    const mobileRegex = /^[0-9]{10}$/;

    const currentErrors = [...errors];
    const fieldErrors = { ...currentErrors[index] };

    switch (field) {
      case "fullName":
        fieldErrors.fullName =
          !value || !nameRegex.test(value)
            ? "Full name is required and should contain only letters"
            : "";
        break;
      case "age":
        fieldErrors.ageGroup = !value ? "Please select an age group" : "";
        break;
      case "gender":
        fieldErrors.gender = !value ? "Gender is required" : "";
        break;
      case "bloodGroup":
        fieldErrors.bloodGroup = !value ? "Blood group is required" : "";
        break;

      case "mobile":
        fieldErrors.mobile =
          !value || !mobileRegex.test(value)
            ? "Enter a valid 10-digit mobile number"
            : "";
        break;
      case "email":
        fieldErrors.email =
          value && !emailRegex.test(value) ? "Enter a valid email address" : "";
        break;

      case "pickupPoint":
        fieldErrors.pickupPoint = !value ? "Pickup point is required" : "";
        break;
      case "foodPreference":
        fieldErrors.foodPreference = !value
          ? "Food preference is required"
          : "";
        break;
      case "medicalCondition":
        fieldErrors.medicalCondition = !value
          ? "Medical condition selection is required"
          : "";
        break;
      case "medicalConditionDetails":
        fieldErrors.medicalConditionDetails =
          form.medicalCondition === "Yes" && !value
            ? "Please specify medical condition details"
            : "";
        break;
      case "emergencyName":
        fieldErrors.emergencyName =
          !value || !nameRegex.test(value)
            ? "Emergency name is required and should contain only letters"
            : "";
        break;
      case "emerContactNumber":
        fieldErrors.emerContactNumber =
          !value || !mobileRegex.test(value)
            ? "Enter a valid emergency contact number"
            : "";
        break;
      case "emergencyRelation":
        fieldErrors.emergencyRelation = !value
          ? "Emergency relation is required"
          : "";
        break;
      default:
        break;
    }

    currentErrors[index] = fieldErrors;
    setErrors(currentErrors);
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;

    // Block invalid characters in fullName and emergencyName (letters and spaces only)
    if (
      (name === "fullName" || name === "emergencyName") &&
      !/^[A-Za-z\s]*$/.test(value)
    ) {
      return;
    }

    // Allow only digits for mobile numbers
    if (
      (name === "mobile" || name === "emerContactNumber") &&
      !/^\d*$/.test(value)
    ) {
      return;
    }

    const updatedForms = [...forms];
    updatedForms[index][name] = value;
    setForms(updatedForms);

    // Call validation for this specific field
    validateSingleField(index, name, value, updatedForms[index]);
  };

  const addForm = () => {
    setForms([...forms, createInitialForm()]);
  };

  const removeForm = (index) => {
    const updatedForms = [...forms];
    updatedForms.splice(index, 1);
    setForms(updatedForms);
  };

  const submitAppForm = (e) => {
    e.preventDefault();

    const isValid = validateForm();
    if (!isValid) return;

    const cleanedForms = forms.map((form) => ({
      ...form,
      medicalConditionDetails:
        form.medicalCondition === "Yes" ? form.medicalConditionDetails : "NA",
      currentMedicationDetails:
        form.currentMedication === "Yes" ? form.currentMedicationDetails : "NA",
    }));

    const payload = { applications: cleanedForms };

    // fetch("https://avirtrekkers.com/api/api/auth/application", {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/application`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to submit application");
        return res.json();
      })
      .then(() => {
        setPopup({
          show: true,
          message: "Application submitted successfully!",
          type: "success",
        });
        setForms([createInitialForm()]);
        setErrors([]);
      })
      .catch(() => {
        setPopup({
          show: true,
          message: "Something went wrong. Please try again.",
          type: "error",
        });
      });
  };

  return (
    <div className="appFormMain">
      <div className="appFormHeader">
        <h1>Trek Registration</h1>
        <p>Fill in the details below to register for your adventure.</p>
        <span className="trekBadge">🏔️ {trekName}</span>
      </div>

      {forms.map((form, index) => (
        <div key={index} className="appFormSub">
          <h2>Applicant {index + 1}</h2>

          <div className="personalInfo">
            <h3 className="formSectionTitle">Personal Details</h3>
            <div className="formInput">
              <label>
                Full Name <span className="requiredStar">*</span>
              </label>
              <input
                type="text"
                name="fullName"
                value={form.fullName}
                onChange={(e) => handleChange(index, e)}
              />
              {errors[index]?.fullName && (
                <span className="error">{errors[index].fullName}</span>
              )}
            </div>

            <div className="formInput">
              <label>
                Age Group <span className="requiredStar">*</span>
              </label>
              <select
                name="age"
                value={form.ageGroup}
                onChange={(e) => handleChange(index, e)}
              >
                <option value="">-- Select Age Group --</option>
                <option value="5-8">5-8</option>
                <option value="9-12">9-12</option>
                <option value="13-18">13-18</option>
                <option value="13-25">18-25</option>
                <option value="25-35">25-35</option>
                <option value="35-45">35-45</option>
                <option value="45-55">45-55</option>
                <option value="55+">55+</option>
              </select>
              {errors[index]?.ageGroup && (
                <span className="error">{errors[index].ageGroup}</span>
              )}
            </div>

            <div className="formInput formInputGender inputFourWidth">
              <label>
                Gender <span className="requiredStar">*</span>
              </label>
              <div className="radioDiv">
                <div>
                  <label>Female</label>
                  <input
                    type="radio"
                    name={`gender-${index}`}
                    value="Female"
                    checked={form.gender === "Female"}
                    onChange={(e) =>
                      handleChange(index, {
                        target: { name: "gender", value: e.target.value },
                      })
                    }
                  />
                </div>
                <div>
                  <label>Male</label>
                  <input
                    type="radio"
                    name={`gender-${index}`}
                    value="Male"
                    checked={form.gender === "Male"}
                    onChange={(e) =>
                      handleChange(index, {
                        target: { name: "gender", value: e.target.value },
                      })
                    }
                  />
                </div>
              </div>
              {errors[index]?.gender && (
                <span className="error">{errors[index].gender}</span>
              )}
            </div>
            <div className="formInput inputFourWidth">
              <label>
                Blood Group <span className="requiredStar">*</span>
              </label>
              <select
                name="bloodGroup"
                value={form.bloodGroup}
                onChange={(e) => handleChange(index, e)}
              >
                <option value="">-- Select --</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
              </select>
              {errors[index]?.bloodGroup && (
                <span className="error">{errors[index].bloodGroup}</span>
              )}
            </div>

            <div className="formInput">
              <label>
                Address
              </label>
              <input
                type="text"
                name="address"
                value={form.address}
                onChange={(e) => handleChange(index, e)}
              />
              {errors[index]?.address && (
                <span className="error">{errors[index].address}</span>
              )}
            </div>
            <div className="formInput">
              <label>
                Mobile Number <span className="requiredStar">*</span>
              </label>
              <input
                type="text"
                name="mobile"
                value={form.mobile}
                onChange={(e) => handleChange(index, e)}
              />
              {errors[index]?.mobile && (
                <span className="error">{errors[index].mobile}</span>
              )}
            </div>
            <div className="formInput">
              <label>Email Id</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={(e) => handleChange(index, e)}
              />
              {errors[index]?.email && (
                <span className="error">{errors[index].email}</span>
              )}
            </div>
            <h3 className="formSectionTitle">Trek Preferences</h3>
            <div className="formInput inputFourWidth">
              <label>
                Pickup Point <span className="requiredStar">*</span>
              </label>
              <select
                name="pickupPoint"
                value={form.pickupPoint}
                onChange={(e) => handleChange(index, e)}
              >
                <option value="">-- Select --</option>
                {pickupOptions.map((point) => (
                  <option key={point} value={point}>
                    {point}
                  </option>
                ))}
              </select>
              {errors[index]?.pickupPoint && (
                <span className="error">{errors[index].pickupPoint}</span>
              )}
            </div>
            <div className="formInput inputFourWidth">
              <label>
                Food Preference <span className="requiredStar">*</span>
              </label>
              <select
                name="foodPreference"
                value={form.foodPreference}
                onChange={(e) => handleChange(index, e)}
              >
                <option value="">-- Select Value --</option>
                {foodOptions.map((food) => (
                  <option key={food} value={food}>
                    {food}
                  </option>
                ))}
              </select>
              {errors[index]?.foodPreference && (
                <span className="error">{errors[index].foodPreference}</span>
              )}
              {/* <p
              style={{
                fontSize: "12px",
                marginTop: "6px",
                padding: "6px 8px",
                backgroundColor: "#f8f9fa",
                borderLeft: "3px solid #28a745",
                color: "#333",
                borderRadius: "4px",
                lineHeight: "1.4",
              }}
            >
              <strong>Note:</strong> All meals during the trek will be strictly
              vegetarian. Please select <strong>"Fasting Food"</strong> only if
              applicable.
            </p> */}
            </div>

            <h3 className="formSectionTitle">Medical Information</h3>
            <div className="formInput formInputGender">
              <label>
                Do you have any medical conditions?{" "}
                <span className="requiredStar">*</span>
              </label>
              <div className="radioDiv">
                <div>
                  <label>Yes</label>
                  <input
                    type="radio"
                    name={`medicalCondition-${index}`}
                    value="Yes"
                    checked={form.medicalCondition === "Yes"}
                    onChange={(e) =>
                      handleChange(index, {
                        target: {
                          name: "medicalCondition",
                          value: e.target.value,
                        },
                      })
                    }
                  />
                </div>
                <div>
                  <label>No</label>
                  <input
                    type="radio"
                    name={`medicalCondition-${index}`}
                    value="No"
                    checked={form.medicalCondition === "No"}
                    onChange={(e) =>
                      handleChange(index, {
                        target: {
                          name: "medicalCondition",
                          value: e.target.value,
                        },
                      })
                    }
                  />
                </div>
              </div>
              {errors[index]?.medicalCondition && (
                <span className="error">{errors[index].medicalCondition}</span>
              )}
            </div>

            {form.medicalCondition === "Yes" ? (
              <div className="formInput">
                <label>
                  Medical Condition Details{" "}
                  <span className="requiredStar">*</span>
                </label>
                <textarea
                  name="medicalConditionDetails"
                  value={form.medicalConditionDetails}
                  onChange={(e) => handleChange(index, e)}
                  placeholder="Describe your condition"
                />
                {errors[index]?.medicalConditionDetails && (
                  <span className="error">
                    {errors[index].medicalConditionDetails}
                  </span>
                )}
              </div>
            ) : (
              ""
            )}

            <h3 className="formSectionTitle">Emergency Contact</h3>
            <div className="formInput">
              <label>
                Emergency Contact Name <span className="requiredStar">*</span>
              </label>
              <input
                type="text"
                name="emergencyName"
                value={form.emergencyName}
                onChange={(e) => handleChange(index, e)}
              />
              {errors[index]?.emergencyName && (
                <span className="error">{errors[index].emergencyName}</span>
              )}
            </div>
            <div className="formInput">
              <label>
                Emergency Contact Number <span className="requiredStar">*</span>
              </label>
              <input
                type="text"
                name="emerContactNumber"
                value={form.emerContactNumber}
                onChange={(e) => handleChange(index, e)}
              />
              {errors[index]?.emerContactNumber && (
                <span className="error">{errors[index].emerContactNumber}</span>
              )}
            </div>
            <div className="formInput">
              <label>
                Relationship with Emergency Contact{" "}
                <span className="requiredStar">*</span>
              </label>
              <input
                type="text"
                name="emergencyRelation"
                value={form.emergencyRelation}
                onChange={(e) => handleChange(index, e)}
              />
              {errors[index]?.emergencyRelation && (
                <span className="error">{errors[index].emergencyRelation}</span>
              )}
            </div>
          </div>

          {forms.length > 1 && (
            <button
              type="button"
              onClick={() => removeForm(index)}
              className="removeBtn"
            >
              Remove
            </button>
          )}
        </div>
      ))}
      <div className="apFormBtns">
        <button type="button" onClick={addForm} className="addMoreBtn">
          Add More
        </button>
        <button onClick={submitAppForm} className="submitFormBtn">
          Submit
        </button>
      </div>

      {popup.show && (
        <Popup
          message={popup.message}
          type={popup.type}
          onClose={() => setPopup({ show: false, message: "", type: "" })}
        />
      )}
    </div>
  );
};

export default ApplicationForm;
